import { Auth } from "@aws-amplify/auth"
import { FunctionComponent, useContext, useState } from "react"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Form from "react-bootstrap/Form"
import Row from "react-bootstrap/Row"
import { AppContext } from "../components/AppContext"

/**
 * This file should be kept in sync between:
 * - bell
 * - gpr-front
 * - doorking-front
 * - management-fees-front
 * - access-control-front
 * - users-front
 */

/** Sign in page where the user can log into AWS Cognito. The user shouldn't see this page if they are already logged in. */
const SignInPage: FunctionComponent = () => {
	const { setIsAuthenticated, setGroups } = useContext(AppContext)
	const [error, setError] = useState<string>()
	const [signingIn, setSigningIn] = useState(false)
	const handleSignIn: React.FormEventHandler<HTMLFormElement> = (event) => {
		event.preventDefault()
		setError(undefined)
		setSigningIn(true)
		const email = (event.target as any).email?.value
		const password = (event.target as any).password?.value
		Auth.signIn(email, password)
			.then(() => {
				// if the login is successful, set groups and isAuthenticated in the AppContext
				Auth.currentSession()
					.then((session) => {
						setGroups(session.getIdToken().payload["cognito:groups"])
						setIsAuthenticated(true)
					})
					.catch((error: any) => {
						console.log(error)
						setError("System Error")
					})
			})
			.catch((error: any) => {
				// if the login fails, set the error message on this page
				console.log(error)
				setError("Incorrect Email or Password")
			})
			.finally(() => setSigningIn(false))
	}
	return (
		<Container>
			<Row className="justify-content-center">
				<Col xs="auto">
					<Form className="mt-4" onSubmit={handleSignIn}>
						<Form.Group className="mb-3" controlId="email">
							<Form.Label>Email address</Form.Label>
							<Form.Control type="email" placeholder="Email" required />
						</Form.Group>
						<Form.Group className="mb-3" controlId="password">
							<Form.Label>Password</Form.Label>
							<Form.Control type="password" placeholder="Password" required />
						</Form.Group>
						{error && <Alert variant={"warning"}>{error}</Alert>}
						<Button variant="primary" type="submit" disabled={signingIn}>
							Sign In
						</Button>
					</Form>
				</Col>
			</Row>
		</Container>
	)
}

export default SignInPage
